import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './destination-facts-manual-temperature-item.module.scss';

export interface DestinationFactsManualTemperatureItemProps {
  /** The class name to apply */
  className?: string;
  /** The text to show as a headline */
  headline?: string;
  /** The text to show as a prefix */
  prefix?: string;
  /** The text to show as the temperature */
  temperature?: string;
}

const DestinationFactsManualTemperatureItem = ({
  className,
  headline,
  prefix,
  temperature,
}: DestinationFactsManualTemperatureItemProps) => {
  const { t } = useI18n();

  return (
    <div className={classNames(styles.component, className)}>
      {headline && (
        <Typography className={styles.headline} tagStyle="labelMedium">
          {headline}
        </Typography>
      )}

      <div className={styles.content}>
        {prefix && (
          <Typography className={styles.prefix} tagStyle="displayMedium">
            {prefix}
          </Typography>
        )}

        {temperature && (
          <Typography className={styles.temperature} tagStyle="displayLarge">
            {temperature}
          </Typography>
        )}

        <Typography className={styles.unit} tagStyle="displayMedium">
          {t('items.common.unitOfMeasure.degrees')}
        </Typography>
      </div>
    </div>
  );
};

DestinationFactsManualTemperatureItem.displayName =
  'DestinationFactsManualTemperatureItem';

export default DestinationFactsManualTemperatureItem;
